import { SerializableObjectSchema, z } from "@repo/utils";

export const SyncStatusSchema = z.enum(["STARTED", "COMPLETED", "FAILED"]);

export const EntityTypeSchema = z.enum([
    "ADDRESSES",
    "COUNTRIES",
    "CURRENCIES",
    "CUSTOMER_ACCOUNTS",
    "CUSTOMER_ARTICLE_NUMBERS",
    "DICTIONARIES",
    "PARTNER_ADDRESSES",
    "PARTNERS",
    "PRICE_LISTS",
    "PRICE_LIST_CUSTOMERS",
    "PRICE_LIST_ENTRIES",
    "PRODUCTS",
    "PRODUCT_VARIANTS",
    "PRODUCT_PRICES",
    "PRODUCT_UNITS",
    "PRODUCT_UNIT_CONVERSIONS",
    "SHIPPING_TERMS",
    "PAYMENT_TERMS",
    "SELLING_ENTITIES",
    "SELLING_ENTITY_CUSTOMER_ACCOUNTS",
    "SELLING_ENTITY_ADDRESSES",
    "SELLING_ENTITY_PARTNERS",
    "CONTACTS",
    "PARTNER_CONTACTS",
    "EMPLOYEES",
    "EMPLOYEE_CUSTOMERS",
]);

export const SyncHistorySchema = z.object({
    id: z.number(),
    orgId: z.string(),
    syncStartedAt: z.string(),
    syncCompletedAt: z.nullish(z.string()),
    syncStatus: SyncStatusSchema,
    entityType: z.nullable(EntityTypeSchema),
    recordsProcessed: z.number(),
    recordsCreated: z.number(),
    recordsUpdated: z.number(),
    recordsFailed: z.number(),
    errorDetails: z.nullable(SerializableObjectSchema),
    syncMetadata: z.nullable(SerializableObjectSchema),
    createdAt: z.string(),
});
